var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"append-to-body":true,"title":_vm.$i18n.t(_vm.title),"fullscreen":_vm.fullscreen,"visible":_vm.isOpen},on:{"close":_vm.handleClose}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }